import {Component, OnInit, Input, ViewContainerRef, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { ChartType, ChartOptions } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { GadgetApiService, PageNotificationService } from '@signature-it/ngx-generic/services';

@Component({
    selector: 'pie-gadget',
    templateUrl: './pie.gadget.html',
    styleUrls: ['./pie.gadget.scss'],
    standalone: false
})
export class PieGadget implements OnInit {
  @Input() title: string;
  @Input() btnText: string;
  @Input() btnLink: string;
  @Input() colors: string[];
  @Input() key: string;

  viewData: any;
  showGadget: boolean = false;
  defaultColors = ['#78C7F4','#F8A1B6','#FBE29D','#66cc99','#df9fbf','#ff9966','#cc99ff','#669999','#99ccff','#ffb366','#a3a375']

  constructor(protected gadgetApiSvc: GadgetApiService,
              protected notifySvc: PageNotificationService,
              protected router: Router,
              protected elRef: ElementRef) {
  }

  ngOnInit() {
    this.gadgetApiSvc.getPieByView(this.key)
        .subscribe(
            res => {
              if (res) {
                this.viewData = res;
                if (this.viewData && this.viewData.length) {

                  this.setChartData();
                }
              } else {
                this.notifySvc.set('Some Error Occurred').show();
              }
            },
            error => {
              this.notifySvc.set(error).show();
            }
        );

  }

  pieChartOptions: ChartOptions<'pie'>;
  pieChartLabels: [];
  pieChartData: number[];
  pieChartType: ChartType = 'pie';
  pieChartLegend = true;
  pieChartColors;
  pieChartPlugins = [pluginDataLabels];

  setChartData() {

    this.pieChartLabels = this.viewData.map(x => x.name);
    this.pieChartData = this.viewData.map(x => x.count);


    this.pieChartColors = [
      {
        backgroundColor: this.defaultColors
      },
    ];
    this.pieChartOptions = {
      responsive: true,
      aspectRatio: 1.5,
      onClick : (event, array) => this.chartClickEvent(event, array),
      // legend: {
      //   position: 'bottom',
      //   fullWidth: true,
      //   labels: {
      //     boxWidth: 9,
      //     fontSize: 7,
      //     fontStyle: 'normal',
      //     usePointStyle: true
      //   }
      // },
      // tooltips: {
      //   enabled: true,
      // },
      plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            // ctx.chart.data.labels[ctx.dataIndex]
            const label = ctx.chart.data.datasets[0].data[ctx.dataIndex];
            return label;
          },
          font: {
            size: 12
          },
          align: 'center',
        },
      }
    };

    this.showGadget = true;
  }

  chartClickEvent(evt, item) {
    if (item[0]) {
      this.router.navigate([this.viewData[item[0]['_index']].link]);
    }
  }

  onBtnClick() {
    this.router.navigate([this.btnLink]);
  }



}
